import React from 'react';

import { VideoSkeleton } from 'src/registry/ui/Skeleton';

type VideoProps = {
    /** Omit where an overlay already draws the loading state, so only one skeleton animates. */
    loading?: boolean;
    setVideoRef: React.RefCallback<HTMLVideoElement>;
};

const Video = ({ loading = false, setVideoRef }: VideoProps) => {
    return (
        <div className="relative aspect-video w-full rounded-xl">
            <video ref={setVideoRef} autoPlay muted playsInline className="aspect-video max-h-full max-w-full" />
            {loading && <VideoSkeleton />}
        </div>
    );
};

export default Video;
